export const getAdminLeaseList = (state) => {
  return state.leaseList;
};

export const getLeaseEditModal = (state) => {
  const { showLeaseEntryModal } = getAdminLeaseList(state);
  return showLeaseEntryModal;
};

export const getLeaseMoveModal = (state) => {
  const { showLeaseMoveModal } = getAdminLeaseList(state);
  return showLeaseMoveModal;
};

export const getLeaseMergeModal = (state) => {
  const { showLeaseMergeModal } = getAdminLeaseList(state);
  return showLeaseMergeModal;
};

export const getLeaseEntryModal = (state) => {
  const { showLeaseEntryModal } = getAdminLeaseList(state);
  return showLeaseEntryModal;
};

export const getSelectedLease = (state) => {
  const { lease } = getAdminLeaseList(state);
  return lease;
};

export const getSelectedLeaseId = (state) => {
  const lease = getSelectedLease(state);
  if (!lease) {
    return null;
  }
  return lease.id;
};

export const getLeaseAddModal = (state) => {
  const { showLeaseAddModal } = getAdminLeaseList(state);
  return showLeaseAddModal;
};
